import {ChangeDetectionStrategy, Component, HostBinding, Input} from "@angular/core";

@Component({
  selector: 'int-calendar-action-cell, [intCalendarActionCell]',
  template: `
    <ng-content></ng-content>
  `,
  styleUrls: ['./int-calendar-action-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntCalendarActionCellComponent {

  @Input() isSelected: boolean | null = null;

  @HostBinding('class.a-selected') get _selected() {
    return this.isSelected;
  }
}
